import { z } from 'zod';
import { centsSchema, cuidSchema } from './common.dto';

/**
 * Payment DTOs. Stripe/PayPal confirm automatically via webhook;
 * IBAN is confirmed MANUALLY by admin/accountant.
 */

/** Admin/accountant manually confirms an IBAN payment for an order. */
export const confirmIbanPaymentSchema = z.object({
  orderId: cuidSchema,
  /** Amount actually received, integer cents (Phase 1 assumes full prepaid amount). */
  amountCents: centsSchema,
  /** Bank/provider reference for the audit trail. */
  providerRef: z.string().trim().max(140).optional(),
  note: z.string().trim().max(1000).optional(),
});
export type ConfirmIbanPaymentDto = z.infer<typeof confirmIbanPaymentSchema>;

/** Initiate a hosted Stripe/PayPal checkout for an order. */
export const initiateCheckoutSchema = z.object({
  orderId: cuidSchema,
});
export type InitiateCheckoutDto = z.infer<typeof initiateCheckoutSchema>;
